// extracted by mini-css-extract-plugin
module.exports = {"root":"EmployeeDetails_root__NujWb","text":"EmployeeDetails_text__1l_ET","details":"EmployeeDetails_details__4OaQW","buoy":"EmployeeDetails_buoy__coMj3"};